import React, { useState, useCallback } from 'react';
import './VideoButton.css';
import { BsYoutube } from 'react-icons/bs';
import VideoModal from './VideoModal';
import { useTranslation } from '../i18n';

// Icône YouTube (live / à venir / replay) qui ouvre le lecteur dans une modale.
// Ctrl/Cmd/Maj + clic : comportement natif du lien (nouvel onglet YouTube).
// Le clic ne remonte pas au parent (carte cliquable, rencontre dépliable…).
// video : { status, videoId, url, title } (cf. findMatchVideo) ; rien n'est affiché si null
function VideoButton({ video, className = '' }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const close = useCallback(() => setOpen(false), []);

    if (!video) return null;

    const handleClick = (e) => {
        e.stopPropagation();
        if (e.ctrlKey || e.metaKey || e.shiftKey) return;
        e.preventDefault();
        setOpen(true);
    }

    return (
        <>
            <a
                className={"video_button " + video.status + (className ? " " + className : "")}
                href={video.url}
                target="_blank"
                rel="noreferrer"
                title={t('video.button.' + video.status) + ' : ' + video.title}
                aria-label={t('video.button.' + video.status)}
                onClick={handleClick}
            >
                <BsYoutube />
            </a>
            {
                open &&
                <VideoModal video={video} onClose={close} />
            }
        </>
    );
}

export default VideoButton;
